export default __webpack_public_path__ + "images/BN.16ad18f.png";